
export const getUserEmail = (user: any) => {
    // If user signed in using username/password, username is a UUID
    // If federated sign-in, it's the <provider>_<email>@domain.com
    //
    let username: string = user.username;
    if (username.includes("@")) {
        // SSO
        if (username.startsWith("Stanford_")) {
            username = username.substring("Stanford_".length);
        }
        if (username.startsWith("StanfordHealthCare_")) {
            username = username.substring("StanfordHealthCare_".length);
        }
        return username;
    } else {
        return user.attributes.email;
    }
};

export enum UserRole {
    ADMIN = "ADMIN",
    BETA = "BETA",
    BASIC = "BASIC",
}

export const getUserRole = (user: any): UserRole => {
    if (user && user.attributes) {
        const customRole = user.attributes["custom:role"];
        if (customRole === "ADMIN") {
            return UserRole.ADMIN;
        }
    }
    return UserRole.BASIC;
};
